import { isPlainObject, get, forEach, has, set, isEmpty, find, map } from 'lodash';

// merge options
const mergeOptions = ( dynamicOptions, staticOptions ) => {
    return map( dynamicOptions, ( dynamicOption ) => {

        // get static option
        const staticOption = find( staticOptions, { name: dynamicOption.name } );

        // check for nested options
        if( ! isEmpty( dynamicOption.options ) && ! isEmpty( staticOption.options ) ) {
            dynamicOption.options = mergeOptions( dynamicOption.options, staticOption.options );
        }

        // patch static option data in dynamic option
        if( ! isEmpty( staticOption ) ) {
            return {
                ...staticOption,
                ...dynamicOption,
            };
        }

        // return original option back
        return dynamicOption;
    } );
};


/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { formatHttpResponse } from 'resolvers/formatHttpResponse';
 */
export const formatHttpResponse = ( response = {} ) => {
    if( isPlainObject( response ) ) {

        // move options from `dataScope` to `data` by merging them (if necessary)
        if( has( response, 'component.dataScope' ) ) {
            const dataOptions = get( response, 'component.data.options', {} );
            const dataScopeOptions = get( response, 'component.dataScope.options', {} );

            // iterate over all `dataScope` options
            forEach( dataScopeOptions, ( config, category ) => {

                // check if `category` exists in `dataOptions`
                // check if `config` refers to options-set `data`
                if( has( dataOptions, category ) && has( dataOptions, get( config, 'refId' ) ) ) {

                    // const static options
                    const dynamicOptions = get( dataOptions, category, [] );
                    const staticOptions = get( config, 'options', [] );

                    try {
                        
                        // update options in `data.options`
                        set( dataOptions, category, mergeOptions( dynamicOptions, staticOptions ) );
                    } catch( error ) {
                        log.error( 'formatHttpResponse', error );
                    }

                } else {

                    // add options to `data` directly (override)
                    set( response, `component.data.options.${ category }`, get( config, 'options', [] ) );
                }
            } );
            
            // delete `dataScope` key
            delete response.component.dataScope;
        }

        /*----------*/

        return {
            __formatted__: true,
            ...response,
        };
    }

    // return response back without modification
    return response;
};
